import { render, staticRenderFns } from "./MConfirmDialog.vue?vue&type=template&id=6cf2816b&"
import script from "./MConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./MConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cf2816b')) {
      api.createRecord('6cf2816b', component.options)
    } else {
      api.reload('6cf2816b', component.options)
    }
    module.hot.accept("./MConfirmDialog.vue?vue&type=template&id=6cf2816b&", function () {
      api.rerender('6cf2816b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MConfirmDialog.vue"
export default component.exports